import type { ReadinessItem } from '../types/hrmsPayrollProcessing.types'

export const PAYROLL_BASE_PATH = '/admin/hrms/payroll'

export const PAYROLL_PROCESSING_PATH = PAYROLL_BASE_PATH + '/payroll-processing'
export const PAYROLL_PROCESSING_CALCULATE_PATH = PAYROLL_PROCESSING_PATH + '/calculate-payroll'
export const PAYROLL_PROCESSING_FINALISE_PATH = PAYROLL_PROCESSING_PATH + '/finalise-payroll'

export const PAYROLL_PERIOD_OPTIONS: { key: string; label: string }[] = [
  { key: 'April 2026', label: 'April 2026' },
  { key: 'May 2026', label: 'May 2026' },
  { key: 'June 2026', label: 'June 2026' },
  { key: 'July 2026', label: 'July 2026' },
  { key: 'August 2026', label: 'August 2026' },
  { key: 'September 2026', label: 'September 2026' },
  { key: 'October 2026', label: 'October 2026' },
  { key: 'November 2026', label: 'November 2026' },
  { key: 'December 2026', label: 'December 2026' },
  { key: 'January 2027', label: 'January 2027' },
  { key: 'February 2027', label: 'February 2027' },
  { key: 'March 2027', label: 'March 2027' },
]

export const PAYROLL_PROCESSING_CHECKLIST_BASE: Omit<ReadinessItem, 'description'>[] = [
  { id: 'tax-exemption', title: 'Tax Exemption Thresholds' },
  { id: 'bank-validation', title: 'Bank Account Validation' },
  { id: 'provident-fund', title: 'Provident Fund Deductions' },
  { id: 'attendance-sync', title: 'Attendance & Leave Sync' },
]
